import { openobserveRum } from "@openobserve/browser-rum";
import config from "./config";
export function initRum() {
  openobserveRum.init({
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    site: config.site,
    organizationIdentifier: config.organizationIdentifier,
    service: config.service,
    env: config.env,
    version: config.version,
    apiVersion: config.apiVersion,
    insecureHTTP: false,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "allow",
    compressIntakeRequests: false,
    // producción y localhost
    allowedTracingUrls: [
      {
        match: /^https:\/\/api\.atentus\.com/,
        propagatorTypes: ["tracecontext", "openobserve"],
      },
      {
        match: /^http:\/\/localhost/,
        propagatorTypes: ["tracecontext", "openobserve"],
      },
    ],
  });
  openobserveRum.startSessionReplayRecording();

  window.OoRum = openobserveRum;
}
export function setRumUser(user) {
  openobserveRum.setUser({
    id: user.id,
    name: user.name,
    email: user.email,
  });
}
export function addBusinessAction(name, data) {
  openobserveRum.addAction(name, data);
}
export function reportError(error, context) {
  openobserveRum.addError(error, context);
}

const NETWORK_ERROR_MESSAGES = ["Failed to fetch", "NetworkError when attempting to fetch resource", "Load failed"];
export function isNetworkError(error) {
  if (!error) return false;
  if (error.name === "AbortError") return true;
  return error.name === "TypeError" && NETWORK_ERROR_MESSAGES.some((msg) => (error.message || "").includes(msg));
}
export function reportFetchError(context, error) {
  if (isNetworkError(error)) return;
  reportError(error, { context });
}
